/* eslint-disable camelcase */
import React from 'react';
import classNames from 'classnames';
import Select from '../../form/Select';
import DatePickerInstance from './DatePickerInstance';

import 'primereact/resources/primereact.min.css';

const BuildGenericUploadForm = ({ formFields, data, updateData, getValidationErrorMessage, allowedSubtypes }) => {
	const getDropdownOptions = (options) => {
		return options.map((option) => {
			return { label: option.name, value: option.code };
		});
	};

	return formFields.map((field) => {
		const errorMessage = getValidationErrorMessage(field.name);
		if (field.control_type === 'dropdown') {
			return (
				<div
					className={classNames(`form-field ${field.name}-field`, { 'validation-error': !!errorMessage })}
					key={`${field.name}`}
				>
					<Select
						handleChange={(value) => updateData(field.name, value[field.name])}
						options={getDropdownOptions(allowedSubtypes?.length > 0 ? allowedSubtypes : field.values)}
						name={field.name}
						label={field.label}
						placeholder="Select..."
						value={data[field.name]}
						className="form-select"
						isSearchable
					/>
					<div className="error-message">{errorMessage}</div>
				</div>
			);
		}
		if (field.control_type === 'text') {
			return (
				<div
					className={classNames(`form-field ${field.name}-field`, { 'validation-error': !!errorMessage })}
					key={`${field.name}`}
				>
					<div className="input-label">
						<span className="label-name">{field.label}</span>
					</div>
					<input
						className="input form-input"
						type="text"
						value={data[field.name] !== null && data[field.name] !== undefined ? data[field.name] : ''}
						onChange={(e) => updateData(field.name, e.target.value)}
					/>
					<div className="error-message">{errorMessage}</div>
				</div>
			);
		}
		if (field.control_type === 'date') {
			return (
				<div
					key={`${field.name}`}
					className={classNames(`form-field date-field ${field.name}-field`, { 'validation-error': !!errorMessage })}
				>
					<div className="input-label">
						<span className="label-name">{field.label}</span>
					</div>
					<DatePickerInstance
						selectedDate={data[field.name]}
						updateDate={(date) => updateData(field.name, date)}
						placeholder="MM/DD/YYYY"
					/>
					<div className="error-message">{errorMessage}</div>
				</div>
			);
		}
		return '';
	});
};

export default BuildGenericUploadForm;
